import React, {
    ChangeEventHandler,
    FormEventHandler,
    KeyboardEventHandler,
    Ref,
} from 'react';
import { DatakatalogMode } from '../datakatalog/constants';
import type { DatakatalogWindowLauncher } from '../datakatalog/standaloneChannel';

interface SearchBarProps {
    handleSubmit: FormEventHandler;
    handleKeyDown: KeyboardEventHandler;
    handleOnFocus: () => void;
    handleOnClick: () => void;
    handleChange: ChangeEventHandler;
    datakatalogOpen: boolean;
    datakatalogMode: DatakatalogMode;
    setDatakatalogMode: (mode: DatakatalogMode) => void;
    setDatakatalogOpen: (open: boolean) => void;
    inputValue: string;
    dropdownExpanded: boolean;
    activeDescendantId?: string;
    listboxId: string;
    inputRef?: Ref<HTMLInputElement>;
    standaloneTab?: DatakatalogWindowLauncher;
}

export const SearchBar = ({
    handleSubmit,
    handleKeyDown,
    handleOnFocus,
    handleOnClick,
    handleChange,
    inputValue,
    datakatalogOpen,
    setDatakatalogOpen,
    dropdownExpanded,
    activeDescendantId,
    listboxId,
    inputRef,
    standaloneTab,
}: SearchBarProps) => {
    const placeholder = 'Skriv inn vegobjekttype eller søkeområde...';

    return (
        <form
            className="c-search-interact"
            role="search"
            aria-label="Søkefelt"
            onSubmit={handleSubmit}
        >
            <i
                className="o-icon-search c-search-interact__search-icon"
                aria-hidden="true"
            />
            <input
                ref={inputRef}
                id="searchText"
                className="c-search-interact__input"
                autoFocus={true}
                autoComplete="off"
                type="search"
                role="combobox"
                aria-label="Søk etter vegobjekttype eller søkeområde"
                aria-autocomplete="list"
                aria-expanded={dropdownExpanded}
                aria-controls={listboxId}
                aria-activedescendant={activeDescendantId}
                onKeyDown={e => handleKeyDown(e)}
                onFocus={handleOnFocus}
                onClick={handleOnClick}
                onChange={handleChange}
                value={inputValue}
                placeholder={placeholder}
            />
            <span className="c-search-interact__divider" aria-hidden="true" />
            {standaloneTab?.asLink && !datakatalogOpen ? (
                <a
                    href={standaloneTab.url}
                    target="_blank"
                    rel="noreferrer"
                    onClick={standaloneTab.onOpen}
                    className="c-search-interact__datakatalog-button o-icon-book"
                    aria-controls="datakatalog"
                    aria-expanded={false}
                    aria-label="Åpne datakatalog"
                    title="Åpne datakatalogen"
                />
            ) : (
                <button
                    type="button"
                    onClick={() =>
                        standaloneTab && !datakatalogOpen
                            ? standaloneTab.onOpen()
                            : setDatakatalogOpen(!datakatalogOpen)
                    }
                    className={`c-search-interact__datakatalog-button o-icon-book ${
                        datakatalogOpen ? 'o-icon-book--active' : ''
                    }`}
                    aria-controls="datakatalog"
                    aria-expanded={datakatalogOpen}
                    aria-label={datakatalogOpen ? 'Lukk datakatalog' : 'Åpne datakatalog'}
                    title="Åpne datakatalogen"
                />
            )}
        </form>
    );
};
